import { render, staticRenderFns } from "./DataProvider.vue?vue&type=template&id=de03a644&"
import script from "./DataProvider.vue?vue&type=script&lang=js&"
export * from "./DataProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports